const hiddenControlVimeo = () => {
	const containers = document.querySelectorAll(".js-vimeo-hide-control");

	if (!containers.length) return;

	containers.forEach(function (container) {
		const iframes = container.querySelectorAll('iframe[src*="vimeo.com"]');

		iframes.forEach(function (iframe) {
			const src = iframe.getAttribute("src");

			if (!src) return;

			const url = new URL(src, window.location.href);
			const shouldLoop = !container.classList.contains("js-vimeo-no-loop");

			url.searchParams.set("autoplay", "1");
			url.searchParams.set("muted", "1");
			url.searchParams.set("loop", shouldLoop ? "1" : "0");
			url.searchParams.set("background", "1");
			url.searchParams.set("autopause", "0");
			url.searchParams.set("playsinline", "1");

			iframe.src = url.toString();

			const observer = new IntersectionObserver(function (entries, observer) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;

					iframe.contentWindow.postMessage(
						JSON.stringify({ method: "play" }),
						"https://player.vimeo.com"
					);

					observer.unobserve(iframe);
				});
			}, {
				threshold: 0.5
			});

			observer.observe(iframe);
		});
	});

};

export { hiddenControlVimeo };
